import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { LocationActivityEventHydration } from './location-activity-event-hydration.dto';

/**
 * A location activity event with hydrated related records.
 */
export class LocationActivityEventDto extends ActivityEventDto {
  hydrated?: LocationActivityEventHydration;
}
